export default "__VITE_ASSET__d3289429__"